(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('profile', {
            parent: 'entity',
            url: '/profile/{id}/{position}',
            data: {
                authorities: ['ROLE_DG', 'ROLE_COMMERCIAL', 'ROLE_ADMIN', 'ROLE_USER', 'ROLE_CONSULTANT'],
                pageTitle: 'Axenteev | Profil'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/profile/public/profile-public.html',
                    controller: 'ProfilePublicController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', '$rootScope', '$state', 'Profile', '$timeout', 'Principal',
                    function($stateParams, $rootScope, $state, Profile, $timeout, Principal) {
                        if ($stateParams.id) {
                            // Get another user profile except if it's the auth user profile
                            return Profile.get({id: $stateParams.id}).$promise
                            .then(function (profile) {
                                if (profile.mine) {
                                    $state.go('my-profile');
                                }
                                return profile;
                            }).catch(function(error) {
                                $state.go('accessdenied');
                            });
                        } else {
                            // Get the auth user profile
                            var deferred = $q.defer();
                            $timeout(function() {
                                $state.go('my-profile');
                                return deferred.reject();
                            }, 100);
                            return deferred.promise;
                        }
                    }
                ],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'profile',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('position-edit', {
            parent: 'profile',
            url: '/position/edit',
            data: {
                authorities: ['ROLE_DG', 'ROLE_COMMERCIAL', 'ROLE_ADMIN', 'ROLE_USER', 'ROLE_CONSULTANT']
            },
            params: {
                profile: {
                    value: {}
                }
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/profile/public/profile-public-position.html',
                    controller: 'ProfilePublicPositionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg'
                }).result.then(function() {
                    $state.go('^', {}, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('my-profile', {
            parent: 'entity',
            url: '/my-profile',
            data: {
                authorities: ['ROLE_DG', 'ROLE_COMMERCIAL', 'ROLE_ADMIN', 'ROLE_USER', 'ROLE_CONSULTANT'],
                pageTitle: 'Axenteev | Mon profil'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/profile/profile.html',
                    controller: 'ProfileController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['Principal', function(Principal) {
                    // Get the auth user profile
                    console.log('my-profile');
                    return Principal.profile();
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'profile',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('linkedin', {
            parent: 'entity',
            url: '/linkedin/add',
            data: {
                authorities: ['ROLE_DG', 'ROLE_COMMERCIAL', 'ROLE_ADMIN', 'ROLE_USER', 'ROLE_CONSULTANT']
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/profile/profile-linkedin-dialog.html',
                    controller: 'ProfileLinkedinDialogController',
                    controllerAs: 'vm'
                }
            }
        })
        .state('my-position-edit', {
            parent: 'my-profile',
            url: '/position/edit',
            data: {
                authorities: ['ROLE_DG', 'ROLE_COMMERCIAL', 'ROLE_ADMIN', 'ROLE_USER', 'ROLE_CONSULTANT']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/profile/profile-position-dialog.html',
                    controller: 'ProfilePositionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Position', function(Position) {
                            return Position.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('my-position-new', {
            parent: 'my-profile',
            url: '/position/new',
            data: {
                authorities: ['ROLE_DG', 'ROLE_COMMERCIAL', 'ROLE_ADMIN', 'ROLE_USER', 'ROLE_CONSULTANT']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/profile/profile-position-dialog.html',
                    controller: 'ProfilePositionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Principal', function(Principal) {
                            return Principal.profile().then(function (profile) {
                                return {
                                    startDate: null,
                                    endDate: null,
                                    organisation: {
                                        id: null,
                                        name: null
                                    },
                                    profile: profile,
                                    title: null,
                                    id: null
                                };
                            });
                        }]
                    }
                }).result.then(function() {
                    $state.go('profile', null, { reload: 'profile' });
                }, function() {
                    $state.go('profile');
                });
            }]
        })
        .state('my-education-edit', {
            parent: 'my-profile',
            url: '/education/edit',
            data: {
                authorities: ['ROLE_DG', 'ROLE_COMMERCIAL', 'ROLE_ADMIN', 'ROLE_USER', 'ROLE_CONSULTANT']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/profile/profile-education-dialog.html',
                    controller: 'ProfileEducationDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Education', function(Education) {
                            return Education.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('my-education-new', {
                parent: 'my-profile',
                url: '/education/new',
                data: {
                    authorities: ['ROLE_DG', 'ROLE_COMMERCIAL', 'ROLE_ADMIN', 'ROLE_USER', 'ROLE_CONSULTANT']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/profile/profile-education-dialog.html',
                        controller: 'ProfileEducationDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['Principal', function(Principal) {
                                return Principal.profile().then(function (profile) {
                                    return {
                                        startDate: null,
                                        endDate: null,
                                        degree: null,
                                        establishment: {
                                            id: null,
                                            name: null
                                        },
                                        profile: profile,
                                        id: null
                                    };
                                });
                            }]
                        }
                    }).result.then(function() {
                        $state.go('profile', null, { reload: 'profile' });
                    }, function() {
                        $state.go('profile');
                    });
                }]
            })
        .state('picture-edit', {
            parent: 'my-profile',
            url: '/picture/edit',
            data: {
                authorities: ['ROLE_DG', 'ROLE_COMMERCIAL', 'ROLE_ADMIN', 'ROLE_USER', 'ROLE_CONSULTANT']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/profile/profile-picture-dialog.html',
                    controller: 'ProfilePictureDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'sm',
                    resolve: {
                        entity: ['Principal', function(Principal) {
                            return Principal.profile();
                        }]
                    }
                }).result.then(function() {
                    $state.go('profile', null, { reload: 'profile' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('profile-init', {
            parent: 'app',
            url: '/profile-init/:key',
            data: {
                pageTitle: 'Axenteev | Complétez votre profil',
                //authorities: ['ROLE_DG', 'ROLE_COMMERCIAL', 'ROLE_ADMIN', 'ROLE_USER', 'ROLE_CONSULTANT']
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/profile/profile-init.html',
                    controller: 'ProfileInitController',
                    controllerAs: 'vm'
                }
            }
        })
        .state('my-profile.contribution', {
            parent: 'my-profile',
            data: {
                authorities: ['ROLE_USER', 'ROLE_ADMIN', 'ROLE_SALES', 'ROLE_DG', 'ROLE_COMMERCIAL', 'ROLE_CONSULTANT']
            },
            params: {
                multiple: false
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/contribution/contribution-dialog.html',
                    controller: 'ContributionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg'
                }).result.then(function() {
                    $state.go('my-profile',{}, { reload: true });
                }, function() {
                    $state.go('my-profile');
                });
            }]
        })

        .state('my-profile.contribution.edit-profile', {
            parent: 'my-profile.contribution',
            url: '/edit-profile',
            data: {
                authorities: ['ROLE_USER', 'ROLE_ADMIN', 'ROLE_SALES', 'ROLE_DG', 'ROLE_COMMERCIAL', 'ROLE_CONSULTANT']
            },
            params: {
                profile: {
                    value: {}
                }
            },
            views: {
              'contrib@': {
                templateUrl: 'app/entities/profile/profile-dialog.html',
                controller: 'ProfileDialogController',
                controllerAs: 'vm'
              }
            }
        })

        .state('profile-init.my-education-new', {
            parent: 'profile-init',
            url: '/education/new',
            data: {
                authorities: ['ROLE_DG', 'ROLE_COMMERCIAL', 'ROLE_ADMIN', 'ROLE_USER', 'ROLE_CONSULTANT']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/profile/profile-education-dialog.html',
                    controller: 'ProfileEducationDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Principal', function(Principal) {
                            return Principal.profile().then(function (profile) {
                                return {
                                    startDate: null,
                                    endDate: null,
                                    degree: null,
                                    establishment: {
                                        id: null,
                                        name: null
                                    },
                                    profile: profile,
                                    id: null
                                };
                            });
                        }]
                    }
                }).result.then(function() {
                    //$state.go('profile-init', null, { reload:  false });
                }, function() {
                    //$state.go('profile-init');
                });
            }]
        })

        .state('profile.new', {
            parent: 'app',
            url: 'new-profile',
            data: {
                authorities: ['ROLE_USER', 'ROLE_ADMIN', 'ROLE_SALES', 'ROLE_DG', 'ROLE_COMMERCIAL', 'ROLE_CONSULTANT']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/profile/profile-dialog.html',
                    controller: 'ProfileDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                firstName: null,
                                lastName: null,
                                picture: null,
                                pictureContentType: null,
                                email: null,
                                phoneNumber: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go($state.current, {}, {reload: true});
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('profile.contribution', {
            parent: 'profile',
            data: {
                authorities: ['ROLE_USER', 'ROLE_ADMIN', 'ROLE_SALES', 'ROLE_DG', 'ROLE_COMMERCIAL', 'ROLE_CONSULTANT']
            },
            params: {
                multiple: false
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/contribution/contribution-dialog.html',
                    controller: 'ContributionDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg'
                }).result.then(function() {
                    $state.go('profile',{}, { reload: true });
                }, function() {
                    $state.go('profile');
                });
            }]
        })


        .state('profile.contribution.new-profile', {
            parent: 'profile.contribution',
            url: '/new-profile',
            data: {
                authorities: ['ROLE_USER', 'ROLE_ADMIN', 'ROLE_SALES', 'ROLE_DG', 'ROLE_COMMERCIAL', 'ROLE_CONSULTANT']
            },
            resolve: {
                entity: function () {
                    return {
                        name: null,
                        id: null
                    };
                }
            },
            views: {
              'contrib@': {
                templateUrl: 'app/entities/profile/profile-dialog.html',
                controller: 'ProfileDialogController',
                controllerAs: 'vm'
              }
            }
        })


        .state('profile.contribution.edit-profile', {
            parent: 'profile.contribution',
            url: '/edit-profile',
            data: {
                authorities: ['ROLE_USER', 'ROLE_ADMIN', 'ROLE_SALES', 'ROLE_DG', 'ROLE_COMMERCIAL', 'ROLE_CONSULTANT']
            },
            params: {
                profile: {
                    value: {}
                }
            },

            resolve: {
                entity: ['$stateParams', 'Profile', function($stateParams, Profile) {
                    return Profile.get({id : $stateParams.id}).$promise;
                }]
            },

            views: {
              'contrib@': {
                templateUrl: 'app/entities/profile/profile-dialog.html',
                controller: 'ProfileDialogController',
                controllerAs: 'vm'
              }
            }
        })
        .state('profile.contribution.rectify-profile', {
            parent: 'profile.contribution',
            url: '/edit-profile',
            data: {
                authorities: ['ROLE_USER', 'ROLE_ADMIN', 'ROLE_SALES', 'ROLE_DG', 'ROLE_COMMERCIAL', 'ROLE_CONSULTANT']
            },
            params: {
                profile: {
                    value: {}
                },
                rectify: true
            },

            resolve: {
                entity: ['$stateParams', 'Profile', function($stateParams, Profile) {
                    return Profile.get({id : $stateParams.id}).$promise;
                }]
            },

            views: {
              'contrib@': {
                templateUrl: 'app/entities/profile/profile-dialog.html',
                controller: 'ProfileDialogController',
                controllerAs: 'vm'
              }
            }
        })
        .state('profile.contribution.new-company', {
            parent: 'profile.contribution',
            url: '/new-company',
            data: {
                authorities: ['ROLE_USER', 'ROLE_ADMIN', 'ROLE_SALES', 'ROLE_DG', 'ROLE_COMMERCIAL', 'ROLE_CONSULTANT']
            },
            resolve: {
                entity: function () {
                    return {
                        name: null,
                        description: null,
                        logo: null,
                        logoContentType: null,
                        id: null
                    };
                }
            },
            views: {
                'contrib@': {
                    templateUrl: 'app/entities/company/company-dialog.html',
                    controller: 'CompanyDialogController',
                    controllerAs: 'vm'
              }
            }
        })

         .state('profile.request-external-network', {
            parent: 'profile',
            url: '/request-external-network',
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/components/organisation-network/external-network-request-dialog.html',
                    controller: 'ExternalNetworkRequestController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Profile', function(Profile) {
                            return Profile.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('profile', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('profile.envoyer-message-commercial', {
            parent: 'profile',
            url: '/envoyer-message-commercial/:commercialId',
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/components/organisation-network/envoyer-message-commercial-dialog.html',
                    controller: 'EnvoyerMessageCommercialDialogController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Profile', function(Profile) {
                            return Profile.get({id : $stateParams.id}).$promise;
                        }],
                        commercial: ['Profile', function(Profile) {
                            return Profile.get({id : $stateParams.commercialId}).$promise;
                        }],

                    }
                }).result.then(function() {
                    $state.go('profile', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }],
            params: {
                'commercialId': null
            }
        })
        .state('my-profile-credits', {
            parent: 'entity',
            url: '/my-profile-credits',
            data: {
                authorities: ['ROLE_DG', 'ROLE_COMMERCIAL', 'ROLE_ADMIN', 'ROLE_USER', 'ROLE_CONSULTANT'],
                pageTitle: 'Axenteev | Mes crédits'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/profile/profile-credit.html',
                    controller: 'ProfileCreditController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['Principal', function(Principal) {
                    // Get the auth user profile
                    console.log('my-profile-credits');
                    return Principal.profile();
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'profile',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })

        .state('profile.message-libre', {
            parent: 'profile',
            url: '/message-libre/{userId}',
            data: {
                authorities: ['ROLE_DG', 'ROLE_COMMERCIAL', 'ROLE_ADMIN', 'ROLE_USER', 'ROLE_CONSULTANT']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/message-libre/message-libre-dialog.html',
                    controller: 'MessageLibreDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Whoswho', function(Whoswho) {
                            return Whoswho.getUser({userId : $stateParams.userId});
                        }]
                    }
                }).result.then(function() {
                    $state.go('profile', null, { reload: false });
                }, function() {
                    $state.go('profile');
                });

            }]
        })
        .state('profile.rectify', {
            parent: 'profile',
            url: '/rectify-profile/{id}',
            data: {
                authorities: ['ROLE_DG', 'ROLE_COMMERCIAL', 'ROLE_ADMIN', 'ROLE_USER', 'ROLE_CONSULTANT']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/rectify-profile/rectify-profile-dialog.html',
                    controller: 'RectifyProfileDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['$stateParams', 'Profile', function($stateParams, Profile) {
                            return Profile.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('profile', null, { reload: false });
                }, function() {
                    $state.go('profile');
                });

            }]
        })
       ;

        /*
        .state('profile.new-profile', {
            parent: 'profile',
            url: '/new-profile',
            data: {
                authorities: ['ROLE_USER', 'ROLE_ADMIN', 'ROLE_SALES', 'ROLE_DG', 'ROLE_COMMERCIAL', 'ROLE_CONSULTANT']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/profile/profile-dialog.html',
                    controller: 'ProfileDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                firstName: null,
                                lastName: null,
                                picture: null,
                                pictureContentType: null,
                                email: null,
                                phoneNumber: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go($state.current, {}, {reload: true});
                }, function() {
                    $state.go('^');
                });
            }]
        });
        */
    }

})();
